import { LINKEDIN_STORAGE } from '../config/identityProviders';
import { userApi } from './api';

export function currentLinkedInRedirectUri(): string {
  return `${window.location.origin}/auth/linkedin/callback`;
}

export async function startLinkedInLogin(): Promise<void> {
  const { data } = await userApi.getLinkedInConfig();
  if (!data.enabled || !data.clientId) {
    throw new Error('LinkedIn sign-in is not configured. Add a LinkedIn app ClientId and ClientSecret to Authorization settings.');
  }

  const redirectUri = currentLinkedInRedirectUri();
  const state = crypto.randomUUID();
  sessionStorage.setItem(LINKEDIN_STORAGE.state, state);
  sessionStorage.setItem(LINKEDIN_STORAGE.redirectUri, redirectUri);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: data.clientId,
    redirect_uri: redirectUri,
    scope: 'openid profile email',
    state,
    enable_extended_login: 'true',
  });

  window.location.assign(`https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`);
}

export function consumeLinkedInOAuthState(): string | null {
  const state = sessionStorage.getItem(LINKEDIN_STORAGE.state);
  sessionStorage.removeItem(LINKEDIN_STORAGE.state);
  return state;
}

export function consumeLinkedInRedirectUri(): string {
  const stored = sessionStorage.getItem(LINKEDIN_STORAGE.redirectUri);
  sessionStorage.removeItem(LINKEDIN_STORAGE.redirectUri);
  return stored || currentLinkedInRedirectUri();
}
